import { useEffect, useState } from "react";
import Plan from "@/assets/videos/plan-working.mp4";
import { getTokenExp } from "../../Services/req_res_decode_encode.js";
import { useNavigate } from "react-router-dom";
const KeyBenefits = () => {
  const [expanded, setExpanded] = useState(false);
  const [carNo, setCardNo] = useState(0);
  const [openAlert, setOpenAlert] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const wrap = document.querySelector(".wrap");
    if (wrap) wrap.scrollTop = 0;
  }, []);

  useEffect(() => {
    if (getTokenExp()) {
      setOpenAlert(false);
    } else {
      setOpenAlert(true);
    }
  }, []);

  const Alters = () => {
    return (
      <>
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-xl p-6 shadow-xl w-[90%] max-w-md text-center"
            style={{ padding: 20 }}
          >
            <h2 className="text-red-600 text-xl font-bold mb-4"></h2>

            <p className="mb-6" style={{ marginTop: 10 }}>
              Your login is expired!
            </p>

            <button
              onClick={() => {
                localStorage.clear();
                setTimeout(() => {
                  window.location.href = import.meta.env.VITE_LOGINURL;
                }, 1000);
              }}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg"
              style={{ width: 50, marginTop: 20 }}
            >
              Ok
            </button>
          </div>
        </div>
      </>
    );
  };

  if (!openAlert) {
    return <Alters />;
  }

  return (
    <div
      className="key-benefits"
      onContextMenu={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      style={{ userSelect: "none" }}
    >
      <div className="header">
        <img
          src="https://www.freelogovectors.net/wp-content/uploads/2021/01/tata-aia-life-logo-freelogovectors.net_.png"
          alt="TATA AIA Logo"
        />
        <div className="header-actions">
          <select className="lang-select" defaultValue="🌐 Choose Language">
            <option value="🌐 Choose Language">🌐 Choose Language</option>
            <option value="Hindi">Hindi</option>
            <option value="Marathi">Marathi</option>
            <option value="Tamil">Tamil</option>
            <option value="Gujarati">Gujarati</option>
            <option value="Telugu">Telugu</option>
            <option value="Bengali">Bengali</option>
            <option value="Kannada">Kannada</option>
          </select>
        </div>
      </div>
      <div className="cc-page-new-persona">
        <div className="hero-compact-1">
          <div className="hero-pill">KEY BENEFITS</div>
          <h1 className="hero-title">Cancer Care Benefits Made Simple</h1>
          <p className="hero-subtitle">
            Flexible protection designed to support treatment costs, recovery needs, income
            disruption and preventive care.
          </p>
        </div>
        <div
          className="noPrint"
          style={{ margin: "16px 0 12px 0", display: "flex", alignItems: "center" }}
        >
          <button
            className="topbar-change text-white bg-[#c8102e] border border-[#c8102e]  rounded-xl font-bold text-sm"
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingLeft: "25px",
              paddingRight: "30px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            ← Back
          </button>
        </div>
        <h2 className="section-title">Core Benefits</h2>
        <div className="benefit-stack">
          {/* 1. Lumpsum Protection */}
          <div
            className={`card card-blue ${expanded ? "expanded" : ""}`}
            onClick={() => {
              if (carNo == 1) {
                setCardNo(0);
                return;
              }
              setCardNo(1);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-header">
              <div className="card-icon">💰</div>
              <div className="card-title">Lumpsum Protection</div>
            </div>

            {carNo == 1 && (
              <div className="card-body1">
                <p
                  style={{
                    fontSize: "15.5px",
                    lineHeight: "1.8",
                  }}
                >
                  <strong>Fixed benefit payout on Cancer Diagnosis</strong>
                </p>

                <ul>
                  <li>
                    <strong>i.</strong> 100% of Sum Assured paid on{" "}
                    <strong>Advanced / End staging</strong> of cancer
                  </li>

                  <li>
                    <strong>ii.</strong> 25% of Sum Assured paid on <strong>Early staging</strong>{" "}
                    of cancer
                  </li>
                </ul>
              </div>
            )}
          </div>

          {/* 2. Long Term Cancer Protection */}
          <div
            className="card card-green benefit-cards"
            onClick={() => {
              if (carNo == 2) {
                setCardNo(0);
                return;
              }
              setCardNo(2);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-header">
              <div className="card-icon">🛡️</div>
              <div className="card-title">Long Term Cancer Protection</div>
            </div>

            {carNo == 2 && (
              <div className="card-body1">
                <p
                  style={{
                    fontSize: "15.5px",
                    lineHeight: "1.8",
                  }}
                >
                  <strong>Long term 30-year cancer premium guarantee</strong>
                </p>
              </div>
            )}
          </div>

          {/* 3. Income During Recovery */}
          <div
            className="card card-amber benefit-cards"
            onClick={() => {
              if (carNo == 3) {
                setCardNo(0);
                return;
              }
              setCardNo(3);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-header">
              <div className="card-icon">📈</div>
              <div className="card-title">Income During Recovery</div>
            </div>

            {carNo == 3 && (
              <div className="card-body1">
                <p>
                  On Diagnosis, choose to receive the lumpsum benefit as <strong>Income</strong> for
                  support during recovery period of <strong>6–18 months</strong>.
                </p>

                <ul>
                  <li>
                    <strong>Choose Income Term :</strong> 1 to 5 Years
                  </li>

                  <li>
                    <strong>Choose Income Frequency :</strong> Annually / Semi-Annually / Quarterly
                    / Monthly
                  </li>
                </ul>
              </div>
            )}
          </div>

          {/* 4. Discounted Preventive Care */}
          <div
            className="card card-purple benefit-cards"
            onClick={() => {
              if (carNo == 4) {
                setCardNo(0);
                return;
              }
              setCardNo(4);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-header">
              <div className="card-icon">❤️</div>
              <div className="card-title">Discounted Preventive Care Services</div>
            </div>

            {carNo == 4 && (
              <div className="card-body1">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Cancer Screening, Vaccinations</strong> and{" "}
                  <strong>Specialist Consultation</strong> at discounted rates.
                </p>
              </div>
            )}
          </div>
        </div>
        <h2 className="benefit-title">How Benefits Work</h2>

        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          }}
        >
          <video
            controls
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: "100%",
              borderRadius: "16px",
              display: "block",
            }}
          >
            <source src={Plan} type="video/mp4" />
            Your browser does not support video playback.
          </video>
        </div>
        <div style={{ paddingBottom: "50px" }}></div>
      </div>
    </div>
  );
};

export default KeyBenefits;
